<template>
  <div class="container">
    <MessagesContainer
      :class="{ 'fixed left-2 right-2 top-2 z-50': currentStoreStore.isMobile }"
    />
  </div>

  <!-- Move product timer to header on desktop -->
  <Teleport to="header">
    <div class="my-2 hidden md:block">
      <ProductTimer />
    </div>
  </Teleport>

  <ProductDetailPage is-simple-product />
</template>

<script lang="ts" setup>
import ProductTimer from '@/components/ProductTimer.vue';
import MessagesContainer from '@/components/Messages/MessagesContainer.vue';
import ProductDetailPage from '@/pages/ProductPage/partials/ProductDetailPage/ProductDetailPage.vue';
import { useCurrentStoreStore } from '@/stores/CurrentStore/CurrentStoreStore.ts';

const currentStoreStore = useCurrentStoreStore();
</script>
